import React, { Component } from 'react';
import { PostProcessing } from 'constants/PostProcessing';
import './DisplayHomeAddress.less';
import { Button, Dimmer, Grid, Loader, Message, Modal, Transition } from 'semantic-ui-react';
import Formsy from 'formsy-react';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import { saveHomeAddress } from 'services/Manager';

const initialState = {
    showAddressDetails: false,
    address: '',
    showAddressEditModal: false,
    savingAddress: false,
    addressMessageSuccess: false,
    saveAddressMessage: '',
    newAddress: ''
};

class DisplayHomeAddress extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount(){
        this.setState({showAddressDetails: true, address: !this.props.sbr.postProcessing || !this.props.sbr.postProcessing[PostProcessing.SERVICE_LOCATION] ? '' : this.props.sbr.postProcessing[PostProcessing.SERVICE_LOCATION][PostProcessing.SERVICE_LOCATION]});
    }

    onSetAddressClick = () => {
        this.setState({showAddressEditModal: true});
    }

    onAddressChange = (e, { value }) => {
        this.setState({newAddress: value});
    }

    onSaveAddressClose = () => {
        this.setState({showAddressEditModal: false, addressMessageSuccess: true, saveAddressMessage: ''})
    }

    saveAddress = async () => {
        this.setState({savingAddress:  true});
        const res = await saveHomeAddress(this.props.sbr.singleBuyerRequestID, this.state.newAddress);
        if(res.resStatus == 200){
            if(this.props.refreshMap){
                this.props.refreshMap(res.data.lat, res.data.lng);
            }
            this.setState({address: res.data.fullAddress, showAddressEditModal: false, addressMessageSuccess: true, saveAddressMessage: ''});
        }
        else{
            this.setState({saveAddressMessage: res.message, addressMessageSuccess: false})
        }

        this.setState({savingAddress: false});

    }

    onEditAddressClick = () => {
        this.setState({ showAddressEditModal: true, newAddress: this.state.address});
    }

    render() {
        return (this.state.showAddressDetails &&
            <div className='diplay-home-address-container'>
                {_.isEmpty(this.state.address) && <>
                    <div className='add-address-button' onClick={this.onSetAddressClick}>
                        <div className='add-address-icon-container'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14.87" height="11.602" viewBox="0 0 14.87 11.602">
                                <g id="Home_Icon" data-name="Home Icon" transform="translate(0 0)">
                                    <g id="Group_16150" data-name="Group 16150">
                                        <path id="Path_29382" data-name="Path 29382" d="M42.672,57.2c0-.659-.006-1.318.006-1.977a.467.467,0,0,1,.141-.315c1.511-1.259,3.031-2.507,4.544-3.764.214-.178.369-.079.536.058l3.61,2.977c.284.234.577.458.848.707a.521.521,0,0,1,.164.336c.011,1.3.009,2.6.006,3.9,0,.374-.136.5-.515.5q-1.337,0-2.674,0c-.352,0-.493-.142-.495-.495,0-.746,0-1.493,0-2.239,0-.417-.14-.557-.559-.56-.465,0-.93,0-1.4,0-.385,0-.529.148-.531.529,0,.756,0,1.512,0,2.268,0,.394-.149.552-.539.554q-1.308.007-2.616,0c-.384,0-.525-.15-.527-.53,0-.649,0-1.3,0-1.948" transform="translate(-40.19 -48.08)" />
                                        <path id="Path_29383" data-name="Path 29383" d="M10.53,2.2c0-.619,0-1.161,0-1.7,0-.411.077-.485.5-.486h1.046c.452,0,.526.072.527.517,0,1.027.005,2.055,0,3.082a.523.523,0,0,0,.217.465c.62.5,1.227,1.01,1.837,1.518.279.232.287.334.052.623-.147.18-.3.358-.445.537-.273.329-.367.34-.689.078l-4.525-3.7Q8.4,2.612,7.76,2.088c-.3-.24-.359-.241-.649,0L1.434,6.762c-.075.062-.151.122-.225.184a.326.326,0,0,1-.525-.061L.214,6.294c-.3-.38-.293-.463.09-.778l2.54-2.083Q4.709,1.9,6.575.374A1.221,1.221,0,0,1,8.351.392L10.53,2.2" transform="translate(0 0)" />
                                    </g>
                                </g>
                            </svg>
                        </div>

                        <div className='set-address-link'>
                            Set Service Location
                        </div>
                    </div>   
                </>
                }

                {!_.isEmpty(this.state.address) && <svg className="side-arrow" xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13">
                        <path id="Polygon_9" data-name="Polygon 9" d="M6.5,0,13,8H0Z" transform="translate(8) rotate(90)" fill="#1e2022" />
                    </svg>
                }

                {!_.isEmpty(this.state.address) && <div className='edit-address'>
                    
                    <div className='address'>
                        <div>
                            <div className='location-icon-container'><svg id="Location" xmlns="http://www.w3.org/2000/svg" width="9.08" height="12.106" viewBox="0 0 9.08 12.106">
                                
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_8929" data-name="Rectangle 8929" width="9.08" height="12.106" fill="none" />
                                    </clipPath>
                                </defs>
                                <g id="Group_16142" data-name="Group 16142" clip-path="url(#clip-path)">
                                    <path id="Path_29385" data-name="Path 29385" d="M0,4.835A4.619,4.619,0,0,1,3.854.054,4.53,4.53,0,0,1,9.018,3.827a4.343,4.343,0,0,1-.677,3.188C7.64,8.067,6.9,9.093,6.179,10.13c-.4.571-.793,1.144-1.192,1.715a.505.505,0,0,1-.705.184.65.65,0,0,1-.188-.184C2.965,10.227,1.83,8.613.715,6.985A4.04,4.04,0,0,1,0,4.835m4.559,1.6A1.892,1.892,0,1,0,2.65,4.614,1.892,1.892,0,0,0,4.559,6.439" transform="translate(-0.001 0)" />
                                </g>
                            </svg>
                            </div>
                        </div>
                        <div>
                            {this.state.address}
                        </div>
                        

                    </div>
                    <div className='edit' onClick={this.onEditAddressClick}>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10.58" height="10.497" viewBox="0 0 10.58 10.497">
                                <g id="Group_16150" data-name="Group 16150" transform="translate(20.57 15.529)">
                                    <g id="Group_16147" data-name="Group 16147" transform="translate(-20.268 -15.229)">
                                        <g id="Group_16148" data-name="Group 16148" transform="translate(0 0)">
                                            <path id="Path_29389" data-name="Path 29389" d="M93.089,0a1.636,1.636,0,0,1,1.169.464c.265.25.524.508.77.777a1.666,1.666,0,0,1-.052,2.377Q93.94,4.661,92.9,5.7,91.2,7.4,89.5,9.1a.673.673,0,0,1-.375.2c-1.043.19-2.084.39-3.127.586-.282.053-.44-.106-.387-.391.2-1.069.4-2.139.6-3.206A.609.609,0,0,1,86.392,6q2.259-2.269,4.525-4.531l.947-.947A1.691,1.691,0,0,1,93.089,0m-6.81,9.208a.479.479,0,0,0,.067,0c.844-.158,1.689-.313,2.531-.477a.539.539,0,0,0,.266-.131Q91.324,6.428,93.5,4.249c.033-.034.064-.07.087-.1L91.348,1.911a.737.737,0,0,0-.059.049q-2.212,2.209-4.422,4.421a.314.314,0,0,0-.087.151c-.169.886-.333,1.772-.5,2.676m7.742-5.52c.206-.2.427-.378.612-.59a1.037,1.037,0,0,0,.005-1.389c-.267-.3-.559-.58-.855-.853a.991.991,0,0,0-.833-.245c-.551.07-.8.541-1.162.85L94.02,3.688" transform="translate(-85.604 0.001)" fill="#377dff" stroke="#377dff" stroke-width="0.6" />
                                        </g>
                                    </g>
                                </g>
                            </svg>


                        </div>
                        <div>
                            Edit
                        </div>
                    </div>
                </div>
                
                }

                <Modal className="home-address-modal" closeOnDimmerClick={false} closeOnEscape={false} onClose={this.onSaveAddressClose} open={this.state.showAddressEditModal} closeIcon>
                    <Modal.Header className='modal-header'>
                        Set Service Location
                    </Modal.Header>
                    <Dimmer.Dimmable as={Modal.Content} blurring dimmed={this.state.savingAddress}>
                        <Dimmer active={this.state.savingAddress} inverted>
                            <Loader>Saving</Loader>
                        </Dimmer>
                        <Transition visible={this.state.saveAddressMessage.length > 0} animation='fade' duration={500}>
                            <Message {...{
                                success: this.state.addressMessageSuccess,
                                error: !this.state.addressMessageSuccess
                            }}>
                                {this.state.saveAddressMessage}
                            </Message>
                        </Transition>

                        <Formsy onValidSubmit={this.saveAddress}>
                            <Grid className="grid-ap">
                                <Grid.Row>
                                    <Grid.Column width={16}>
                                        <DGTextbox
                                            name={`address`}
                                            label="Address"
                                            value={this.state.address}
                                            required
                                            onChange={this.onAddressChange}
                                            maxLength={1024}
                                            validationErrors={{
                                                isDefaultRequiredValue: 'This field is required'
                                                
                                            }} />
                                    </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>

                                    <Grid.Column width={16} className='action-buttons'>
                                        <div>
                                            <Button className="save-btn" type='submit' icon>
                                                Save
                                            </Button>
                                        </div>
                                        <div>
                                            <Button className="cancel-btn" type='button' icon onClick={this.onSaveAddressClose}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Formsy>                        
                    </Dimmer.Dimmable>
                </Modal>

            </div>
        )
    }
}

export default DisplayHomeAddress;
